import styled from 'styled-components';
import { device } from '../media_queries';

const MainReportDescription = styled.div`
  width: 25%;
  /* height: ${props => props.size ? "670px" : "335px"};
  670px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding-top: 80px;*/
  margin-bottom: 10px;
  border-radius: 6px;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07);
  background-color: #CCE3E2;
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

const ReportTitle = styled.div`
  width: 75%;
  padding: 10px;
  color: white;
  font-size: 1rem;
  font-weight: bolder;
  border-radius: 6px;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07);
  background-color: #514E5F;
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

const ReportInfo = styled.div`
  width: 75%;
  /* height: 35%; */
  border-radius: 6px;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

const ReportInfoTitle = styled.h2`
  font-weight: 1000;
  font-size: 1rem;
  padding: 10px;
  border: 1px solid black;
  border-radius: 6px;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07);
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

const ReportInfoData = styled.p`
  font-weight: 600;
  padding: 10px;
  font-size: .7rem;
  border: 1px solid black;
  border-radius: 6px;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07);
  @media ${device.mobileS} {
    
  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {
    
  }
  @media ${device.desktop} {
    
  }
`;

export { MainReportDescription, ReportTitle, ReportInfo, ReportInfoTitle, ReportInfoData };